module.exports = __webpack_public_path__ + "static/media/404.532484f5.png";